var App = {
    $body:$("body"),

    init: function init() {
        this.$App = $("#App");
        this.selectedLang = "fr";

        var Utils = require("utils");
        this.utils = new Utils();

        var HeaderView = require("views/headerView");
        this.headerView = new HeaderView();

        var FooterView = require("views/footerView");
        this.footerView = new FooterView();

        var Router = require("router");
        this.router = new Router();

        Backbone.history.start();
    },

    updateFromRouter:function(){
        var self = this;
        this.utils.gatherData(function(){
            self.render();
        });
    },

    render:function(){
    	console.log("render app ?");
    	this.utils.fillTranslations();
    	this.headerView.render();
        this.footerView.render();
    	this.bindEvents();
        this.utils.displayMenuActiveBtn("explore");
    },

    bindEvents:function(){
    	var self = this;

        $(".collection_btn").on("click",function(){
            location.href = $(this).attr("data-page")+".php#"+App.selectedLang;
        });
    }

};

module.exports = App;
window.App = App;